<template>
  <div class="d-flex justify-center">
    <vue-speedometer
    class="mx-auto my-auto"
      :width="165"
      :height="115"
      :segments="5"
      maxSegmentLabels="0"
      :currentValueText="porcentagem + '%'"
      :segmentColors='["#E57373", "#EF9A9A", "#FFB74D", "#FFCC80", "#81C784", "#43A047"]'
      :value="ponteiro"
    />
  </div>
</template>

<script>
import VueSpeedometer from 'vue-speedometer'

export default {
  name: 'alerta',
  props: {
    valorMeta: {
      type: Number
    },
    valorMes: {
      type: Number
    }
  },
  components: {
    VueSpeedometer
    //  apexchart: VueApexCharts
  },
  data: () => ({
    porcentagem: '',
    ponteiro: ''
  }),
  methods: {
    calcularPorcentagem () {
      if (this.valorMeta > 0 && this.valorMes > 0) {
        this.porcentagem = parseInt((this.valorMes / this.valorMeta) * 100)
        this.ponteiro = (this.valorMes / this.valorMeta) * 1000
      } else {
        this.porcentagem = 0
        this.ponteiro = 1
      }
    }
  },
  watch: {
    valorMeta (val) {
      this.calcularPorcentagem()
    },
    valorMes (val) {
      this.calcularPorcentagem()
    }
  }
}
</script>
